module.exports = __webpack_public_path__ + "images/cbc9ac5040372817807531f167bde283.svg";